<template>
  <BaseInfo GroupFlag="department"></BaseInfo>
</template>

<script>
import BaseInfo from "./Base.vue";
export default {
  components: {
    BaseInfo,
  },
};
</script>

<style>
</style>